const DMS_ACCOUNT_TYPES_MAPPING = {
  S: 'Service',
  I: 'Parts',
  A: 'Accounting',
  'FI': 'Finance',
  'SL': 'Inventory'
};

const DMS_ACCOUNT_NAME_TYPE_MAPPING = {
  Service: 'S',
  Parts: 'I',
  Accounting: 'A',
  Finance: 'FI',
  Inventory: 'SL'
};

module.exports = {
  DMS_ACCOUNT_TYPES_MAPPING,
  DMS_ACCOUNT_NAME_TYPE_MAPPING
};